module.exports = __webpack_public_path__ + "img/nocust.d7daa63e.svg";